// extracted by mini-css-extract-plugin
export var cardSelected = "_i5-2";
export var image = "_i5-1";
export var table = "_i5-0";